import { useWeb3React } from '@web3-react/core';
import useSWR from 'swr';
import { verifyChainConfig } from '../../../helpers';
import { ITradePair__factory } from '../../../config/contracts/typechain';
import { formatUnits } from 'ethers/lib/utils';
import useTokenDetails from '../useTokenDetails';
import { config } from '../../../config/config';
import { EnabledChains } from '../../../config/constants';

const useMinCollateral = (tradePairAddress?: string) => {
    const { library, chainId } = useWeb3React();

    const { decimals, error: tokenDetailsError } = useTokenDetails(
        config.addresses[chainId as EnabledChains[number]]?.collateral
    );

    const { data, error } = useSWR(
        library && chainId && decimals && tradePairAddress
            ? ['minCollateral', library, chainId, decimals, tradePairAddress]
            : null,
        async (_, library, chainId, decimals, tradePairAddress) => {
            if (!verifyChainConfig(chainId)) return;

            const tradePairContract = ITradePair__factory.connect(
                tradePairAddress,
                library
            );

            const minMargin = await tradePairContract.minMargin();

            return formatUnits(minMargin, decimals);
        }
    );

    return {
        minCollateral: data,
        isLoading: !error && !data && !tokenDetailsError,
        error: error || tokenDetailsError,
    };
};

export default useMinCollateral;
